<!--<template>
  <v-btn :elevation="4" fab outlined
         style="position:absolute;top:7px;right:12px"
         @click="removeFromCart(product)">
    <v-icon x-small>mdi-close</v-icon>
  </v-btn>
</template>-->
<template>
  <v-card flat align-right>
<button
    type="button"
    class="close"
    aria-label="Remove"
    @click="removeFromCart(product)"
>
<span style="font-weight: bold">x</span>
</button>
  </v-card>
  </template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RemoveFromCart',
  props: {
    product: Object
  },
  methods: mapActions([
    'removeFromCart'
  ])
}
</script>
